<template>
  <div :class="$style.milestones_stub">
    <div :class="$style.left_side">
      <div :class="$style.pie"></div>
      <div :class="$style.footer">
        <skeleton-item
          type="bar"
          :style="{ height: '12px', width: '60px' }"
        />
        <div :class="$style.delimeter"></div>
        <skeleton-item
          type="bar"
          :style="{ height: '12px', width: '60px' }"
        />
      </div>
    </div>
    <div :class="$style.right_side">
      <div :class="$style.rows">
        <div v-for="row in topRows" :key="row.id" :class="$style.row">
          <skeleton-item
            v-for="(width, index) in row.cols"
            :key="index"
            type="bar"
            :style="{ height: '12px', width: `${width}px` }"
          />
        </div>
      </div>
      <div :class="$style.rows">
        <div v-for="row in bottomRows" :key="row.id" :class="$style.row">
          <skeleton-item
            v-for="(width, index) in row.cols"
            :key="index"
            type="bar"
            :style="{ height: '12px', width: `${width}px` }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonItem from '$$vueCmp/skeletons/skeletonItem.vue';

export default {
  name: 'StubChartMilestones',
  components: {
    SkeletonItem
  },
  data() {
    return {
      topRows: [
        { id: 1, cols: [151, 60, 81] },
        { id: 2, cols: [104, 39, 60] },
        { id: 3, cols: [151, 59, 41] },
      ],
      bottomRows: [
        { id: 4, cols: [34, 39, 60] },
        { id: 5, cols: [212, 60, 60] },
      ]
    };
  }
}
</script>

<style module src="../less/chart.less"></style>
